import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/pages/page-not-found-module/page-not-found/page-not-found.component.ts